import { environment } from "src/environments/environment";
import { Colors } from "src/app/models/enums/colors";
import { ILegacyValueRule } from "src/app/models/legacyValueRule";

export class APP {
  // STORAGE
  public static LOCAL_STORAGE_TOKEN_KEY_NAME = 'token';
  public static LOCAL_STORAGE_TOKEN_DECODED = 'decodedToken';
  public static LOCAL_STORAGE_TOKEN_TYPE_KEY_NAME = 'tokenType';
  public static LOCAL_STORAGE_ROLE = 'role';
  public static LOCAL_STORAGE_REFRESH_TOKEN = environment.location === 'prod' ? 'refreshToken' : 'refreshToken' + `-${environment.location}`;
  public static LOCAL_STORAGE_USER_ID = environment.location === 'prod' ? 'userId' : 'userId' + `-${environment.location}`;
  public static LOCAL_STORAGE_LAST_ROUTE = 'route';
  public static LOCAL_STORAGE_MAP_CONFIG = 'mapConfig';
  public static LOCAL_STORAGE_HIDE_SHARED_STOP_ALERT = 'hideSharedStopAlert';
  public static LOCAL_STORAGE_HIDDEN_ROUTES = 'hiddenRoutes';

  public static DEFAULT_PAGE_SIZE = 10;
  public static MAX_PAGE_SIZE = 999;

  // Favourites persist a D2D free stop (lat/lng only) with these sentinel ids; they are not real stop ids.
  public static FAVOURITE_FREE_IN_STOP_ID = 0;
  public static FAVOURITE_FREE_OUT_STOP_ID = 1;

  public static MAXQUEUE_EMAIL = 8000;
  public static MAXQUEUE_PUSHNOTIFICATION = 8000;
  public static MAXQUEUE_SMS = 200;

  // AUTH
  public static HEADER_RESPONSE_TOKEN_AUTH_KEY = 'Authorization';
  public static PASSWORD_MIN_LENGTH = 12;
  public static SIGN_IN_MAX_ATTEMPTS = 5;
  public static SIGN_IN_CODE_LENGTH = 8;
  public static SIGN_IN_INITIAL_TIMER = '02:00';
  public static SIGN_IN_PASSWORD_RESET_TIMER = '03:00';
  public static SIGN_IN_TIME_FINISHED = '00:00';
  public static DEFAULT_ROUTE = 'users';

  public static appsPrivacyAndTermsOptions = [
    { name: 'Nemi', privacy: `http://www.nemi.mobi/app/legal/`, terms: `http://www.nemi.mobi/app/terms/`, owner: 'Nemi Mobility Solutions SL', someLanguages: true },
    { name: 'AMB', privacy: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', terms: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', owner: null, someLanguages: false },
    { name: 'SierraCar', privacy: 'https://sierracar.es/politica-privacidad/', terms: 'https://sierracar.es/wp-content/uploads/2021/03/TC_SierraCar.pdf', owner: 'la Mancomunidad de servicios Valle Norte del Lozoya', someLanguages: false },
    { name: 'Cotsalsina', privacy: `http://www.nemi.mobi/cotsalsina/legal/`, terms: `http://www.nemi.mobi/cotsalsina/terms/`, owner: 'Cots Alsina SL', someLanguages: false },
    { name: 'Pnds', privacy: `http://www.nemi.mobi/pnds/legal/`, terms: `http://www.nemi.mobi/pnds/terms/`, owner: 'Autocares del Panades SA', someLanguages: false },
    { name: 'Tuvisa', privacy: `http://www.nemi.mobi/tuvisa/legal/`, terms: `http://www.nemi.mobi/tuvisa/terms/`, owner: 'el Ayuntamiento de Vitoria-Gasteiz', someLanguages: false },
    { name: 'Dipucar', privacy: `http://www.nemi.mobi/dipucar/legal/`, terms: `http://www.nemi.mobi/dipucar/terms/`, owner: 'la Diputación Provincial de Palencia', someLanguages: false }
  ];

  // ROUTE SETUP CONFIG
  public static DEFAULT_STOP_RADIUS = 75;
  public static MIN_STOP_RADIUS = 1;
  public static MAX_STOP_RADIUS = 999;
  public static DEFAULT_DRIVING_SPEED = 50;
  public static TOWN_STOP_METADATA_PROPERTIES = ['gtfs-id', 'parking-length', 'parking-number', 'parking-orientation'] as const;
  public static ORDERED_STOPS_TYPE = 'orderedStops';

  // MAP
  public static DEFAULT_MAP_ZOOM = 15;
  public static TOWN_ZOOM_MIN_SPAN = 0.01;
  public static ROUTE_WAYPOINTS_CHUNK_SIZE = 25;

  // COLORS
  public static HEX_COLOR_PATTERN = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/;
  public static HEX_COLOR_MAX_LENGTH = 7;

  // LEGACY VALUES
  public static LEGACY_VALUE_RULES: ILegacyValueRule[] = [
    { key: 'color', legacyValue: '#FFFFFFFF', value: Colors.TRANSPARENT },
  ];
  public static LEGACY_TERRAIN_KEYS: Record<string, string> = {
    connection_ids: 'connection-ids',
    intersection_ids: 'intersection-ids',
    town_segment_ids: 'town-segment-ids',
  };

  public static PREDEFINED_COLORS = new Set<string>([
    Colors.TRANSPARENT,
    Colors.BLUE,
    Colors.ORANGE_1,
    Colors.ORANGE_2,
    Colors.PINK,
    Colors.PURPLE,
    Colors.PURPLE_LIGHT,
    Colors.PRIMARY_GREEN,
    Colors.SECONDARY_GREEN,
    Colors.RED,
    Colors.YELLOW,
    Colors.GREY,
  ]);

  // RESTRICTIONS
  public static RESTRICTIONS_NAME_COLLATOR = new Intl.Collator(undefined, { sensitivity: 'base' });
}
